"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJWTRegex = exports.imsEmailRegex = exports.unsafeQueryParams = exports.commonHeaders = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const headers = {
    CONTENT_LENGTH: 'content-length',
    X_ADOBE_CLIENTSESSION: 'x-adobe-clientsession',
    X_ADOBE_STATUS: 'x-adobe-status',
    X_CIP: 'x-cip',
    X_DEBUG_ID: 'x-debug-id',
    X_FORWARDED_FOR: 'x-forwarded-for',
    X_IMS_CLIENTID: 'x-ims-clientid',
    X_REQUEST_ID: 'x-request-id',
};
exports.commonHeaders = new Set([
    headers.CONTENT_LENGTH,
    headers.X_ADOBE_CLIENTSESSION,
    headers.X_ADOBE_STATUS,
    headers.X_CIP,
    headers.X_DEBUG_ID,
    headers.X_REQUEST_ID,
]);
exports.unsafeQueryParams = new Set(['access_token', 'code', 'state', 'client_secret']);
exports.imsEmailRegex = new RegExp("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+(?:[a-z]*)\\b$", 'i');
exports.isJWTRegex = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
